import './table301group/style';
import FormStructure from './table301group/form_structure';

export default FormStructure;